import logoWithTextImg from "~/assets/logo-with-text.svg";
import LandingContent from "./content";
import { LandingBirbyAnimation, LandingTopAnimationLeft, LandingTopAnimationRight } from "./animation";
import blidzQrImg from "~/assets/blidz-qr.png";
import downloadImg from "~/assets/landing-page/download.svg";
import arrowRightImg from "~/assets/landing-page/arrow-right.svg";
import { Button } from "~/components/ui/button";
import titleImg1 from "~/assets/landing-page/title-1.svg";
import titleImg2 from "~/assets/landing-page/title-2.svg";
import titleImg3 from "~/assets/landing-page/title-3.svg";
import titleImg4 from "~/assets/landing-page/title-4.svg";
import titleImg5 from "~/assets/landing-page/title-5.svg";
import titleMdImg1 from "~/assets/landing-page/title-md-1.svg";
import titleMdImg2 from "~/assets/landing-page/title-md-2.svg";
import titleMdImg3 from "~/assets/landing-page/title-md-3.svg";
import titleMdImg4 from "~/assets/landing-page/title-md-4.svg";
import { useState, useEffect } from "react";
import { cn } from "~/lib/utils";

export default function LandingHeader({ onGetApp, onGoToShop }: { onGetApp: () => void; onGoToShop: () => void }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);
  return (
    <div id="landing-header-container" className="h-full w-full bg-gradient-to-b from-yellow-200 via-white to-white">
      <div id="landing-header-nav" className="flex h-[64px] w-full flex-row justify-between p-[16px]">
        <button id="landing-header-logo-button" className="cursor-pointer">
          <img id="landing-header-logo" src={logoWithTextImg} alt="Blidz" className="h-8" />
        </button>
        <button
          id="landing-header-download-button"
          className="inline-flex h-9 cursor-pointer items-center justify-center gap-1 rounded-xl border border-black/10 bg-white/40 px-3 py-2 hover:shadow-[0px_0px_12px_0px_rgba(0,0,0,0.25)]"
          onClick={onGetApp}
        >
          <div className="justify-start text-sm leading-tight font-semibold text-neutral-900">Download</div>
          <img src={downloadImg} alt="Download" className="h-4 w-4" />
        </button>
      </div>
      <LandingContent
        className={cn(
          "flex flex-row items-start justify-center",
          "transition-all duration-700 ease-out",
          isVisible ? "blur-0 scale-100 opacity-100" : "blur-6xl scale-50 opacity-0"
        )}
      >
        <LandingTopAnimationLeft className="hidden lg:block" />
        <div className="flex w-full max-w-full flex-col items-center justify-center lg:max-w-[562px]">
          <div className="flex gap-[20px] md:hidden">
            <img src={titleImg1} className="h-[48px] w-[48px]" />
            <img src={titleImg2} className="h-[48px] w-[48px]" />
            <img src={titleImg3} className="h-[48px] w-[48px]" />
            <img src={titleImg4} className="h-[48px] w-[48px]" />
            <img src={titleImg5} className="h-[48px] w-[48px]" />
          </div>
          <div className="hidden gap-[30px] md:flex lg:hidden">
            <img src={titleMdImg1} className="h-[80px] w-[80px]" />
            <img src={titleMdImg2} className="h-[80px] w-[80px]" />
            <img src={titleMdImg3} className="h-[80px] w-[80px]" />
            <img src={titleMdImg4} className="h-[80px] w-[80px]" />
          </div>
          <div className="flex flex-col items-center justify-center text-center text-5xl leading-[52px] font-semibold text-nowrap text-neutral-900/90 md:text-6xl md:leading-[64px]">
            <p>Make money,</p>
            <p>Save money,</p>
            <p>Have fun!</p>
          </div>
          <div className="h-[16px]" />
          <div id="landing-header-cta-buttons" className="flex flex-col items-start justify-start gap-4 md:flex-row">
            <Button
              id="landing-header-download-cta"
              variant="primary"
              size="big"
              onClick={onGetApp}
              className={cn("w-40", isVisible ? "blur-0 scale-100 opacity-100" : "scale-50 opacity-0 blur-xl")}
            >
              <div className="justify-start text-base leading-normal font-bold text-neutral-900">Download</div>
              <img src={downloadImg} alt="Download" className="h-4 w-4" />
            </Button>
            <Button
              id="landing-header-shop-cta"
              variant="ghost"
              size="big"
              onClick={onGoToShop}
              className={cn(isVisible ? "blur-0 scale-100 opacity-100" : "scale-50 opacity-0 blur-xl")}
            >
              <div className="justify-start text-base leading-normal font-bold text-neutral-900">Go Shopping</div>
              <img src={arrowRightImg} alt="Shopping" className="h-4 w-4" />
            </Button>
          </div>
          <div className="h-[12px]" />
          <div className="hidden flex-col items-center justify-start gap-2 lg:flex">
            <div className="justify-start text-xs leading-none font-medium text-neutral-600">
              Scan code to download app
            </div>
            <img className="h-20 w-20 rounded" src={blidzQrImg} />
          </div>
          <div className="mt-[-90px] ml-[30px] hidden md:block">
            <LandingBirbyAnimation className="w-[450px]" />
          </div>
        </div>
        <LandingTopAnimationRight className="hidden lg:block" />
      </LandingContent>
    </div>
  );
}
